export const DEALER_DETAILS = '@@dealer/DETAILS';
export const BOOKING_DETAILS = '@@BOOKING/DETAILS';
export const CURRENT_STEP = '@@STEP/CURRENT';
export const CODE_PAS_FOR_ANNUALSERVICE = '@@SERVICE/CODEPAS_FOR_ANNUALSERVICE';
export const CAR_INFOS = '@@CAR/INFOS';
export const CAR_KILO = '@@CAR/KILO';
export const SERVICES = '@@BOOKING/SERVICES';
export const SERVICES_SELECTED = '@@BOOKING/SERVICES_SELECTED';
export const COMMENT_SERVICES = '@@BOOKING/COMMENT_SERVICES';
export const PERSONEL_INFOS = '@@BOOKING/PERSONEL_INFOS';
export const PREMIUM_SERVICES_DSVALET = '@@BOOKING/PREMIUM_SERVICES_DSVALET';
export const SELECTED_PREMIUM_SERVICES = '@@BOOKING/SELECTED_PREMIUM_SERVICES';
export const LIST_PREMIUM_SERVICES = '@@BOOKING/LIST_PREMIUM_SERVICES';
export const EDITMODE = '@@BOOKING/EDITMODE';
export const DIALOG_CONFIRMATION_CHANGE_STEP = '@@DIALOGS/CONFIRMATION_CHANGE_STEP';
export const FILES = '@@BOOKING/FILES';
export const ATTACHMENTID = '@@BOOKING/ATTACHMENTID';
export const DATELIMIT = '@@BOOKING/DATELIMIT';
export const SELECTED_LAT = '@@BOOKING/SELECTED_LAT';
export const SELECTED_LONG = '@@BOOKING/SELECTED_LONG';
export const FILTER_DEALERS_BY = '@@BOOKING/FILTER_DEALERS_BY';
export const FILTER_BY_CHOICE = '@@BOOKING/FILTER_BY_CHOICE';
export const DEALERS_FILTRED = '@@BOOKING/DEALERS_FILTRED';
export const IDRDVLEADS = '@@BOOKING/IDRDVLEADS';
